{ "compressionlevel":-1,
 "height":23,
 "infinite":false,
 "layers":[
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":23,
         "id":1,
         "locked":true,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":25,
         "x":0,
         "y":0
        },
        {
         "id":2,
         "image":"environment.png",
         "locked":true,
         "name":"image",
         "opacity":1,
         "type":"imagelayer",
         "visible":false,
         "x":0,
         "y":0
        },
        {
         "draworder":"topdown",
         "id":3,
         "name":"data:encounters",
         "objects":[
                {
                 "height":0,
                 "id":1,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":140,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":70
                        },
                        {
                         "x":280,
                         "y":70
                        },
                        {
                         "x":280,
                         "y":140
                        },
                        {
                         "x":210,
                         "y":140
                        },
                        {
                         "x":210,
                         "y":210
                        },
                        {
                         "x":0,
                         "y":210
                        },
                        {
                         "x":0,
                         "y":70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Knock Knock"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"1"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":350,
                 "y":210
                },
                {
                 "height":0,
                 "id":2,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":210
                        },
                        {
                         "x":210,
                         "y":210
                        },
                        {
                         "x":210,
                         "y":280
                        },
                        {
                         "x":0,
                         "y":280
                        },
                        {
                         "x":0,
                         "y":210
                        },
                        {
                         "x":-70,
                         "y":210
                        },
                        {
                         "x":-70,
                         "y":70
                        },
                        {
                         "x":0,
                         "y":70
                        },
                        {
                         "x":0,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"The Shield"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"2"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":280,
                 "y":490
                },
                {
                 "height":0,
                 "id":3,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":210
                        },
                        {
                         "x":140,
                         "y":210
                        },
                        {
                         "x":140,
                         "y":280
                        },
                        {
                         "x":70,
                         "y":280
                        },
                        {
                         "x":70,
                         "y":210
                        },
                        {
                         "x":-70,
                         "y":210
                        },
                        {
                         "x":-70,
                         "y":70
                        },
                        {
                         "x":0,
                         "y":70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Gunning For It"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"3"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":280,
                 "y":840
                },
                {
                 "height":0,
                 "id":70,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":-70
                        },
                        {
                         "x":140,
                         "y":-70
                        },
                        {
                         "x":140,
                         "y":70
                        },
                        {
                         "x":210,
                         "y":70
                        },
                        {
                         "x":210,
                         "y":0
                        },
                        {
                         "x":420,
                         "y":0
                        },
                        {
                         "x":420,
                         "y":70
                        },
                        {
                         "x":350,
                         "y":70
                        },
                        {
                         "x":350,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":210
                        },
                        {
                         "x":350,
                         "y":210
                        },
                        {
                         "x":350,
                         "y":350
                        },
                        {
                         "x":210,
                         "y":350
                        },
                        {
                         "x":210,
                         "y":280
                        },
                        {
                         "x":140,
                         "y":280
                        },
                        {
                         "x":140,
                         "y":350
                        },
                        {
                         "x":70,
                         "y":350
                        },
                        {
                         "x":70,
                         "y":280
                        },
                        {
                         "x":0,
                         "y":280
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Back-to-back"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"4"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":560,
                 "y":980
                },
                {
                 "height":0,
                 "id":74,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":0
                        },
                        {
                         "x":210,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":140
                        },
                        {
                         "x":280,
                         "y":280
                        },
                        {
                         "x":70,
                         "y":280
                        },
                        {
                         "x":70,
                         "y":210
                        },
                        {
                         "x":0,
                         "y":210
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"The End is Knight"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"5"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":980,
                 "y":1120
                },
                {
                 "height":0,
                 "id":75,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":-70
                        },
                        {
                         "x":280,
                         "y":-70
                        },
                        {
                         "x":280,
                         "y":0
                        },
                        {
                         "x":350,
                         "y":0
                        },
                        {
                         "x":350,
                         "y":210
                        },
                        {
                         "x":280,
                         "y":210
                        },
                        {
                         "x":280,
                         "y":280
                        },
                        {
                         "x":210,
                         "y":280
                        },
                        {
                         "x":210,
                         "y":210
                        },
                        {
                         "x":70,
                         "y":210
                        },
                        {
                         "x":70,
                         "y":70
                        },
                        {
                         "x":0,
                         "y":70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Greed, the Devouring"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"6"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":1190,
                 "y":980
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        },
        {
         "draworder":"topdown",
         "id":4,
         "locked":true,
         "name":"data:units",
         "objects":[
                {
                 "height":32,
                 "id":12,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"swordlord"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":350
                },
                {
                 "height":32,
                 "id":13,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":560
                },
                {
                 "height":32,
                 "id":14,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":560
                },
                {
                 "height":32,
                 "id":17,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":910
                },
                {
                 "height":32,
                 "id":18,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":910
                },
                {
                 "height":32,
                 "id":21,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":1050
                },
                {
                 "height":32,
                 "id":22,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":1050
                },
                {
                 "height":32,
                 "id":23,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":980
                },
                {
                 "height":32,
                 "id":24,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":1120
                },
                {
                 "height":32,
                 "id":25,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":1190
                },
                {
                 "height":32,
                 "id":27,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":1190
                },
                {
                 "height":32,
                 "id":28,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":1260
                },
                {
                 "height":32,
                 "id":29,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1260,
                 "y":1120
                },
                {
                 "height":32,
                 "id":30,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1330,
                 "y":1120
                },
                {
                 "height":32,
                 "id":31,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1330,
                 "y":1190
                },
                {
                 "height":32,
                 "id":32,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1260,
                 "y":1190
                },
                {
                 "height":32,
                 "id":33,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":420
                },
                {
                 "height":32,
                 "id":34,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":350
                },
                {
                 "height":32,
                 "id":36,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"bow"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":210,
                 "y":700
                },
                {
                 "height":32,
                 "id":37,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":770
                },
                {
                 "height":32,
                 "id":38,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":280,
                 "y":770
                },
                {
                 "height":32,
                 "id":39,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":490,
                 "y":700
                },
                {
                 "height":32,
                 "id":40,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":980
                },
                {
                 "height":32,
                 "id":41,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":350,
                 "y":1120
                },
                {
                 "height":32,
                 "id":43,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":420,
                 "y":1050
                },

                {
                 "height":32,
                 "id":44,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":1260
                },
                {
                 "height":32,
                 "id":45,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":1260
                },
                {
                 "height":32,
                 "id":47,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":1050
                },
                {
                 "height":32,
                 "id":48,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":1190
                },
                {
                 "height":32,
                 "id":49,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":1120
                },
                {
                 "height":32,
                 "id":50,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":840,
                 "y":1330
                },
                {
                 "height":32,
                 "id":51,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":1260
                },
                {
                 "height":32,
                 "id":52,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1190,
                 "y":1330
                },
                {
                 "height":32,
                 "id":53,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":1400
                },
                {
                 "height":32,
                 "id":54,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1190,
                 "y":1400
                },
                {
                 "height":32,
                 "id":55,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1190,
                 "y":1050
                },
                {
                 "height":32,
                 "id":56,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1470,
                 "y":1120
                },
                {
                 "height":32,
                 "id":57,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1330,
                 "y":980
                },
                {
                 "height":32,
                 "id":58,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"advanced"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1400,
                 "y":1260
                },
                {
                 "height":32,
                 "id":59,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"devil"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"devil"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"archdevil"
                        },
                        {
                         "name":"maxhealth",
                         "type":"int",
                         "value":30
                        },
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"armored"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1400,
                 "y":980
                },
                {
                 "height":32,
                 "id":77,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":1260
                },
                {
                 "height":32,
                 "id":79,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"highpriest"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":1400
                },
                {
                 "height":32,
                 "id":80,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spearknight"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":490,
                 "y":280
                },
                {
                 "height":32,
                 "id":81,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"gunner"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":210,
                 "y":1050
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":false,
         "x":0,
         "y":0
        }],
 "nextlayerid":5,
 "nextobjectid":82,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.8.6",
 "tileheight":70,
 "tilesets":[
        {
         "firstgid":1,
         "source":"tileset.json"
        }],
 "tilewidth":70,
 "type":"map",
 "version":"1.8",
 "width":25
}
